import React from 'react'

export default function Header() {

  return (
    
    <>
    <div className="myprimarylightbg d-lg-block py-2">
        <div className='container'> 
        <div className='row'>
            
<div className="col-md-1 text-sm-right text-center my-auto">
    <img src='/images/railway.png' className="my-auto" alt="South Eastern Railway Mixed Higher Secondary School, Adra" width="100px"></img>
</div>
           <div className="col-md-10 text-center my-auto">
<h1 className="text-light header1 ml-2 text-center">South Eastern Railway Mixed Higher Secondary School, Adra</h1>
<p>Affiliated to The CBSE (Up to XII) Affiliation No: 2480016, School No: 19247</p>
</div>
</div>
</div>
</div>


</>
  )
}
